import type { FormField } from '@cli-types/core-engine/schema.js'
import { escapeAttribute, jsString } from '@cli-utils/text.js'
import { renderFileUploadFieldJsxFieldControllerTemplate } from '@next-adapter/templates/renderers/generators/form-pipeline/form-component-shared/generate-file-upload-field-jsx.js'
import { errorMessageLine } from './error-message-line.js'
import { fieldContainerClass } from './field-container-class.js'
import { formLabelWithDescriptionLine } from './form-label-with-description-line.js'
import { inputClass } from './input-class.js'

export function generateFileUploadFieldJSX(
  field: FormField,
  name: string,
  label: string,
  hintJSX: string,
  requiredStar: string
): string {
  const accept = field.accept || '*/*'
  const multiple = field.multiple ? '\n                multiple' : ''
  return renderFileUploadFieldJsxFieldControllerTemplate({
    name: name,
    fieldContainerClass: fieldContainerClass(field.height),
    formLabelWithDescriptionLine: formLabelWithDescriptionLine(
      name,
      label,
      requiredStar,
      hintJSX,
      '              '
    ),
    escapeAttribute: escapeAttribute(accept),
    multiple: multiple,
    inputClass: inputClass(field.height),
    errorMessageLine: errorMessageLine(jsString(name), '              ')
  })
}
